<template lang="html">
  <v-card
    class="pa-4 ma-0"
    elevation="4"
    >
    <h1>WISE Supply</h1>
    <ul class="mb-5">
      <li>
        Click on the legend to disable/enable pie slices and get recalculated percentage values
      </li>
      <li>
        Click on the "Staked"-slice to get a comparison between "Regular-" and "Insurance Stakes"
      </li>
    </ul>

    <div
      v-if="graphLoading"
      class="text-center"
      >
      <v-progress-circular
      indeterminate
      color="#29abb5"
      class="my-5"
      ></v-progress-circular>
      <p>
        Loading Graph...
      </p>
    </div>
    <div v-else>
      <highcharts
      class="flex-grow-1 flex-shrink-0"
      :options="chartOptionsSupply"
      ></highcharts>
    </div>
  </v-card>



  <!-- <v-flex class="flex-grow-1 flex-shrink-0"> -->

    <!-- <v-card
      class="pa-2 ma-2"
      outlined
      tile
      >
      <h1>Circulating WISE</h1>
      <ul class="mb-5">
        <li>Staked WISE (locked)</li>
        <li>Non-staked WISE (liquid)</li>
      </ul>

      <h3>Total Public WISE: {{ this.supply - this.$store.state.uniswapBalance | formatWISE("a", 3, "WISE") }}</h3>
      <div
        v-if="graphLoading"
        class="text-center"
        >
        <v-progress-circular
        indeterminate
        color="#29abb5"
        class="my-5"
        ></v-progress-circular>
        <p>
          Loading Graph...
        </p>
      </div>
      <div v-else>
        <highcharts
        :options="chartOptionsStaked"
        ></highcharts>
      </div>
    </v-card>
    <v-card
      class="pa-2 ma-2"
      outlined
      tile
      >
      <h1>Liquidity</h1>
      <ul class="mb-5">
        <li>Uniswap Supply</li>
        <li>Non-staked WISE</li>
      </ul>

      <h3>Total Liquid Wise: {{ this.supply - this.$store.state.totalStaked | formatWISE("a", 3, "WISE") }}</h3>
      <div
        v-if="graphLoading"
        class="text-center"
        >
        <v-progress-circular
        indeterminate
        color="#29abb5"
        class="my-5"
        ></v-progress-circular>
        <p>
          Loading Graph...
        </p>
      </div>
      <div v-else>
        <highcharts
        :options="chartOptionsLiquidity"
        ></highcharts>
      </div>
    </v-card> -->

  <!-- </v-flex> -->

</template>

<script>
import {
    Chart
  } from "highcharts-vue";
  import Highcharts from "highcharts";
  import HighchartsMore from "highcharts/highcharts-more";
  // import dark from "highcharts/themes/dark-unica";
  import drilldown from "highcharts/modules/drilldown"

  HighchartsMore(Highcharts);
  drilldown(Highcharts);

  // dark(Highcharts);

  // Highcharts.setOptions({
  //   // colors: ['#29abb5', '#ffdc00', '#33b1f6', '#3c44b1', '#00ffff']
  //   colors: ['#FFD900', '#29ABB5', '#3c44b1'],
  // });

  // Highcharts.setOptions({
  //   colors: Highcharts.map(['#FFD900', '#29ABB5', '#3c44b1'], function(color) {
  //     return {
  //       radialGradient: {
  //         cx: 0.5,
  //         cy: 0.3,
  //         r: 0.7
  //       },
  //       stops: [
  //         [0, color],
  //         [1, Highcharts.color(color).brighten(-0.3).get('rgb')] // darken
  //       ]
  //     };
  //   })
  // });

  import {
    mapState
  } from 'vuex';

  export default {
    name: 'StakingPercentage',
    data() {
      return {
        data: [],
        graphLoading: true,
        chart: null,
        supply: 0,
      }
    },
    components: {
      highcharts: Chart,
    },
    created() {
      this.generateData();
    },
    computed: {
      chartOptionsSupply() {
        return {
          chart: {
            backgroundColor: null,
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
            type: 'pie',
            style: {
              fontFamily: "Roboto, sans-serif"
            }
          },
          title: {
            text: ''
          },
          credits: {
            text: 'wiseinfo.io',
            href: "https://wiseinfo.io",
            style: {
              fontSize: "12px",
              color: "#aaaaaa"
            },
            position: {
              x: -20,
              y: -20
            }
          },
          tooltip: {
            pointFormat: '<b>{point.y:,.0f} WISE ({point.percentage:.2f}%)</b>'
          },
          plotOptions: {
            pie: {
              showInLegend: true,
              allowPointSelect: true,
              cursor: 'pointer',
              borderWidth: 0,
              size: "100%",
              // borderColor: "#323234",
              dataLabels: {
                // alignTo: 'plotEdges',
                style: {
                  fontSize: "11px",
                },
                inside: true,
                distance: -70,
                enabled: true,
                format: '<b>{point.name}</b>:<br /> {point.percentage:.2f} %<br />{point.y:,.0f} WISE'
              }
            }
          },
          series: [{
            name: "Total Minted Supply",
            colorByPoint: true,
            // colors: ['#FFD900', '#29ABB5', '#3c44b1'],
            // colors: Highcharts.map(['#33B1F6', '#3c44b1', '#FFD900'], function(color) {
            colors: Highcharts.map(['#33B1F6', '#29ABB5', '#ff61ad'], function(color) {
              // colors: Highcharts.map(['#387BD4', '#FFD900'], function (color) {
              return {
                radialGradient: {
                  cx: 0.5,
                  cy: 0.3,
                  r: 0.7
                },
                stops: [
                  [0, color],
                  [1, Highcharts.color(color).brighten(-0.3).get('rgb')] // darken
                ]
              };
            }),
            data: [],
          }],
          drilldown: {
            series: []
          }
        }
      },
      // chartOptionsStaked() {
      //   return {
      //     chart: {
      //       backgroundColor: null,
      //       plotBackgroundColor: null,
      //       plotBorderWidth: null,
      //       plotShadow: false,
      //       type: 'pie',
      //       width: 350,
      //       style: {
      //         fontFamily: "Ubuntu"
      //       }
      //     },
      //     title: {
      //       text: ''
      //     },
      //     credits: {
      //       text: 'wiseinfo.io',
      //       href: "https://wiseinfo.io",
      //       style: {
      //         fontSize: "12px",
      //         color: "#aaaaaa"
      //       },
      //       position: {
      //         x: -20,
      //         y: -20
      //       }
      //     },
      //     tooltip: {
      //       pointFormat: '<b>{point.y:,.0f} WISE ({point.percentage:.2f}%)</b>'
      //     },
      //     plotOptions: {
      //       pie: {
      //         allowPointSelect: true,
      //         cursor: 'pointer',
      //         borderWidth: 0,
      //         // borderColor: "#323234",
      //         dataLabels: {
      //           style: {
      //             fontSize: "10px",
      //           },
      //           inside: true,
      //           distance: -70,
      //           enabled: true,
      //           format: '<b>{point.name}</b>:<br /> {point.percentage:.2f} %<br />{point.y:,.0f} WISE'
      //         }
      //       }
      //     },
      //     series: [{
      //       colorByPoint: true,
      //       // colors: ['#FFD900', '#29ABB5', '#3c44b1'],
      //       colors: Highcharts.map(['#33B1F6', '#3c44b1'], function(color) {
      //         return {
      //           radialGradient: {
      //             cx: 0.5,
      //             cy: 0.3,
      //             r: 0.7
      //           },
      //           stops: [
      //             [0, color],
      //             [1, Highcharts.color(color).brighten(-0.3).get('rgb')] // darken
      //           ]
      //         };
      //       }),
      //       data: [],
      //     }]
      //   }
      // },
      // chartOptionsLiquidity() {
      //   return {
      //     chart: {
      //       backgroundColor: null,
      //       plotBackgroundColor: null,
      //       plotBorderWidth: null,
      //       plotShadow: false,
      //       type: 'pie',
      //       width: 350,
      //       style: {
      //         fontFamily: "Ubuntu"
      //       }
      //     },
      //     title: {
      //       text: ''
      //     },
      //     credits: {
      //       text: 'wiseinfo.io',
      //       href: "https://wiseinfo.io",
      //       style: {
      //         fontSize: "12px",
      //         color: "#aaaaaa"
      //       },
      //       position: {
      //         x: -20,
      //         y: -20
      //       }
      //     },
      //     tooltip: {
      //       pointFormat: '<b>{point.y:,.0f} WISE ({point.percentage:.2f}%)</b>'
      //     },
      //     plotOptions: {
      //       pie: {
      //         allowPointSelect: true,
      //         cursor: 'pointer',
      //         borderWidth: 0,
      //         // borderColor: "#323234",
      //         dataLabels: {
      //           inside: true,
      //           style: {
      //             fontSize: "10px",
      //           },
      //           distance: -70,
      //           enabled: true,
      //           format: '<b>{point.name}</b>:<br /> {point.percentage:.2f} %<br />{point.y:,.0f} WISE'
      //         }
      //       }
      //     },
      //     series: [{
      //       colorByPoint: true,
      //       // colors: ['#FFD900', '#29ABB5', '#3c44b1'],
      //       colors: Highcharts.map(['#3c44b1', '#FFD900'], function(color) {
      //         return {
      //           radialGradient: {
      //             cx: 0.5,
      //             cy: 0.3,
      //             r: 0.7
      //           },
      //           stops: [
      //             [0, color],
      //             [1, Highcharts.color(color).brighten(-0.3).get('rgb')] // darken
      //           ]
      //         };
      //       }),
      //       data: [],
      //     }]
      //   }
      // },
      ...mapState({
        totalSupply: state => state.totalSupply,
        totalStaked: state => state.totalStaked,
        totalStakedInsurance: state => state.totalStakedInsurance,
        uniswapBalance: state => state.uniswapBalance,
      }),
    },
    watch: {
      totalSupply() {
        this.generateData();
      },
      totalStaked() {
        this.generateData();
      },
      totalStakedInsurance() {
        this.generateData();
      },
      uniswapBalance() {
        this.generateData();
      },
    },
    methods: {
      receivedAllNeededData() {
        return (
          this.$store.state.totalSupply >= 0 &&
          this.$store.state.totalStaked >= 0 &&
          this.$store.state.totalStakedInsurance >= 0 &&
          this.$store.state.uniswapBalance >= 0
        );
      },
      generateData() {
        if (this.receivedAllNeededData()) {

          this.supply = this.$store.state.totalSupply + this.$store.state.totalStaked;
          // this.supply = this.$store.state.totalSupply;

          // let uniswapBalance = this.$store.state.uniswapBalance;
          // console.log(`uniswapBalance: ${uniswapBalance}`);

          let dataEntrySupplyUniswap = {
            name: "Uniswap",
            drilldown: null,
            y: this.$store.state.uniswapBalance
          }
          // let dataEntrySupplyPublic = {
          //   name: "Public",
          //   y: this.supply - this.$store.state.uniswapBalance
          // }
          let dataEntryStakedStaked = {
            name: "Staked",
            drilldown: "Staked",
            y: this.$store.state.totalStaked
          }
          let dataEntryStakedLiquid = {
            name: "Wallets/Liquid",
            drilldown: null,
            y: this.supply - this.$store.state.uniswapBalance - this.$store.state.totalStaked
          }
          // let dataEntryLiquidityUniswap = {
          //   name: "Uniswap",
          //   y: this.$store.state.uniswapBalance
          // }
          // let dataEntryLiquidityPublid = {
          //   name: "Public NotStaked",
          //   y: this.supply - this.$store.state.uniswapBalance - this.$store.state.totalStaked
          // }
          // let dataEntryNonStaked = {
          //   name: "Not Staked",
          //   y: this.$store.state.totalSupply - this.$store.state.totalStaked - this.$store.state.uniswapBalance
          //   // y: 150000000
          // }
          // this.chartOptionsSupply.series[0].data = [dataEntrySupplyPublic, dataEntrySupplyUniswap];
          this.chartOptionsSupply.series[0].data = [dataEntryStakedStaked, dataEntryStakedLiquid, dataEntrySupplyUniswap];
          // this.chartOptionsStaked.series[0].data = [dataEntryStakedStaked, dataEntryStakedLiquid];
          // this.chartOptionsLiquidity.series[0].data = [dataEntryLiquidityPublid, dataEntryLiquidityUniswap];
          this.chartOptionsSupply.drilldown.series[0] = {
            name: "Staked",
            id: "Staked",
            data: [
              [
                "Regular Stakess",
                this.$store.state.totalStaked - this.$store.state.totalStakedInsurance
              ],
              [
                "Insurance Stakes",
                this.$store.state.totalStakedInsurance
              ]
            ]
          }
          this.graphLoading = false;
        }
      },
    },
  }
</script>

<style lang="css" scoped>
</style>
